// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"faf213ab","486":"d4927570","778":"15bf3635","938":"f6ff9982","950":"3558562c"}[chunkId] + ".chunk.js";
};